module.exports = __webpack_public_path__ + "img/page.3aee364f.png";